import { combineActions, handleActions } from 'redux-actions'
import sortBy from 'lodash/sortBy'
import * as rawActions from '../actions'

function _addFieldsToIteration(iteration) {
  return {
    ...iteration,
    AIObjects: [],
    AnnotationOwners: [],
    Answerers: [],
    Approvers: [],
    Contents: [],
    FormControls: [],
    Forms: [],
    Metrics: [],
    Pages: [],
    PagesTotalCount: 0,
    Reviewers: [],
    isFiltersLoaded: false,
    isMetricsLoaded: false,
    isPagesLoaded: false,
  }
}

function _addIteration(state, iteration) {
  let result = [...state, _addFieldsToIteration(iteration)]
  result = sortBy(result, (itr) => itr.Id)
  return result
}

function _updateIteration(state, updatedIteration) {
  return state.map((iteration) =>
    iteration.Id === updatedIteration.Id ? { ...iteration, ...updatedIteration } : iteration
  )
}

function _updateIterationFilters(state, iterationId, filters) {
  return state.map((iteration) =>
    iteration.Id === iterationId ? { ...iteration, ...filters, isFiltersLoaded: true } : iteration
  )
}

function _updateIterationPages(state, { IterationId }, pages) {
  return state.map((iteration) =>
    iteration.Id === IterationId
      ? {
          ...iteration,
          Pages: pages.Pages,
          PagesTotalCount: pages.TotalCount,
        }
      : iteration
  )
}

function _updateIterationMetrics(state, iterationId, metrics) {
  return state.map((iteration) =>
    iteration.Id === iterationId ? { ...iteration, Metrics: metrics, isMetricsLoaded: true } : iteration
  )
}

const defaultState = []

export default handleActions(
  {
    [rawActions.getIterations.success](state, { response }) {
      return response.data.map((iteration) => _addFieldsToIteration(iteration))
    },
    [rawActions.getIterationById.success](state, { response }) {
      return _addIteration(state, response.data)
    },
    [combineActions(
      rawActions.updateIteration.success,
      rawActions.deployIteration.success,
      rawActions.getIterationStatus.success,
      rawActions.getIterationDeploymentStatus.success
    )](state, { response }) {
      return _updateIteration(state, response.data)
    },
    [rawActions.getPagesByIterationId.success](state, { payload, response }) {
      return _updateIterationPages(state, payload, response.data)
    },
    [rawActions.getFiltersByIterationId.success](state, { payload, response }) {
      return _updateIterationFilters(state, payload, response.data)
    },
    [combineActions(rawActions.getMetricsByIterationId.success, rawActions.downloadIterationMetrics.success)](
      state,
      { payload, response }
    ) {
      return _updateIterationMetrics(state, payload, response.data)
    },
    [rawActions.trainProject.success](state, { response }) {
      return _addIteration(state, response.data)
    },
    [rawActions.updateIterationTrainingStatus](state, { payload }) {
      return _updateIteration(state, payload)
    },
    [rawActions.updateIterationDeploymentStatus](state, { payload }) {
      return _updateIteration(state, {
        Id: payload.Id,
        DeploymentStatus: payload.DeploymentStatus,
        DeploymentExpirationTime: payload.ExpirationTime,
      })
    },
  },
  defaultState
)
